import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=7347a2c6&scoped=true&"
import script from "./Recover.vue?vue&type=script&lang=ts&"
export * from "./Recover.vue?vue&type=script&lang=ts&"
import style0 from "./Recover.vue?vue&type=style&index=0&id=7347a2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347a2c6",
  null
  
)

export default component.exports